import { useState } from "react";
import {
  ThemeIcon,
  UnstyledButton,
  Group,
  Text,
  useMantineTheme,
  Box,
  ActionIcon,
  Stack,
} from "@mantine/core";
import { useLocation } from "react-router-dom";
import {
  IconCalendarEvent,
  IconChevronUp,
  IconHome,
  IconLivePhoto,
  IconRocket,
  IconUsers,
  IconUserScan,
  IconChevronDown,
  IconCameraCheck,
} from "@tabler/icons-react";
import { createStyles } from "@mantine/emotion";
import { AppConstants } from "utils/constants";

// interface MainLinkProps {
//   icon: React.ReactNode;
//   color: string;
//   label: string;
// }

const useStyles = createStyles((theme, _, u) => ({
  mainLink: {
    "&.open": {
      // [`& .${getRef('submenu')}`]: {
      //     paddingLeft: 15,
      //     opacity: 0,
      //     maxHeight: 0,
      // },
      // [`& .${getRef('menuArrow')}`]: {
      //     transform: 'rotate(180deg)',
      // },
    },
  },

  button: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexGrow: 1,
    padding: theme.spacing.xs,
    borderRadius: theme.radius.sm,
    color: theme.colors.dark[0],
    maxWidth: 51,
    height: 51,
    overflow: "hidden",
    transition: "all .1s ease-in",
    "&.open": {
      maxWidth: 300,
    },
    ">div": {
      flexWrap: "nowrap",
    },
    [u.light]: {
      color: theme.colors.dark[9],
    },
    border: "none",
    "&:hover": {
      background: theme.colors.dark[6],
      ".themeIcon": {
        color: theme.colors.brand[1],
        // backgroundColor:theme.colors.brand[4] ,
        opacity: 1,
        svg: {
          transform: "scale(1)",
        },

        // [u.light]:{
        //     color: theme.colors.brand[4]
        // },
      },
      [u.light]: {
        background: theme.colors.gray[1],
      },
    },
    ".themeIcon": {
      opacity: 0.7,
      color: theme.colors.brand[5],
      backgroundColor: "transparent",
      transition: "all .2s ease-in",
      paddingLeft: 2,
      marginRight: 2,
      [u.light]: {
        color: theme.colors.dark[8],
      },
    },
    "&.active": {
      backgroundColor: theme.colors.dark[5],
      opacity: 1,
      color: theme.white,

      [u.light]: {
        color: theme.colors.dark[9],
        backgroundColor: theme.colors.gray[2],
      },

      ".themeIcon": {
        opacity: 1,
        color: theme.white,
        [u.light]: {
          color: theme.colors.dark[9],
        },
        // backgroundColor: theme.colors.dark[4],
      },
    },
  },
  menuItem: {
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs,
    borderRadius: 0,
    paddingLeft: 34,
    transition: "all .2s",
    width: "100%",
    color: theme.colors.dark[0],
    [u.light]: {
      color: theme.colors.dark[7],
    },
    "&:hover": {
      color: theme.colors.brand[1],
      [u.light]: {
        color: theme.colors.dark[9],
      },
    },
    "&.active": {
      color: theme.white,
      backgroundColor: theme.colors.dark[7],
      borderLeft: `3px solid ${theme.colors.teal[9]}`,
      borderColor: theme.colors.brand[4],
      [u.light]: {
        color: theme.colors.brand[6],
        backgroundColor: theme.colors.gray[0],
        borderColor: theme.colors.brand[5],
      },
    },
  },
  subMenHolder: {
    // ref: getRef('submenu'),
    overflow: "hidden",
    maxHeight: 300,
    transition: "all .154s",
    opacity: 1,
    marginLeft: 25,
    // paddingLeft: 15,
    borderLeft: `1px dashed ${theme.colors.brand[3]}`,
  },
  menuArrow: {
    // ref: getRef('menuArrow'),
    color: theme.colors.dark[0],
    [u.light]: {
      color: theme.colors.dark[9],
    },
    "&:hover": {
      backgroundColor: theme.colors.brand[9],
      [u.light]: {
        backgroundColor: theme.colors.gray[0],
      },
    },
  },
  // themeIcon:{
  //   color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[3],
  // }
}));

function MainLink({ icon, color, label, route, items, onClick, active }) {
  const theme = useMantineTheme();
  const borderColor = active ? theme.colors[`${color}`][8] : "transparent";
  const { classes } = useStyles(active);
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const buttonClick = () => {
    onClick({ label, route, items });
    setIsOpen(!isOpen);
  };

  let activeLink = "";
  let btnClass = `menu-link ${classes.button}`;
  // if(isOpen){
  //     btnClass += ' open';
  // }
  if (active) {
    btnClass += " active";
  }
  return (
    <Box className={isOpen ? `${classes.mainLink} open` : classes.mainLink}>
      <Group wrap={false}>
        <UnstyledButton
          className={btnClass}
          onClick={() => {
            buttonClick();
          }}
        >
          <Group
            style={{ flexGrow: 1, minWidth: 150 }}
            spacing={17}
            wrap={false}
          >
            {/* <Tooltip position='right' label={label} withArrow> */}
            {/* <ThemeIcon color={color} size="lg" style={{borderColor:borderColor}} variant="light">
                {icon}
              </ThemeIcon> */}

            <ThemeIcon
              size="md"
              radius={"sm"}
              className="themeIcon"
              variant="transparent"
              style={{
                borderColor: borderColor,
                borderWidth: 0,
              }}
            >
              {icon}
            </ThemeIcon>
            {/* </Tooltip> */}
            <Text size="sm" style={{ flexGrow: 1, fontWeight: 500 }}>
              {label}
            </Text>
          </Group>

          {/* {items && items.length ? (
          <ActionIcon
            variant="transparent"
            co
            // className={classes.menuArrow}
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <IconChevronDown size={14} /> : <IconChevronUp size={14} />}
          </ActionIcon>
        ) : null} */}

          {items && items.length ? (
            <ThemeIcon
              size={"sm"}
              variant="default"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? (
                <IconChevronDown
                  stroke={AppConstants.ICON_STROKE_WIDTH}
                  size={AppConstants.ICON_SIZE}
                />
              ) : (
                <IconChevronUp
                  stroke={AppConstants.ICON_STROKE_WIDTH}
                  size={AppConstants.ICON_SIZE}
                />
              )}
            </ThemeIcon>
          ) : null}
        </UnstyledButton>
      </Group>

      <Box
        className={classes.subMenHolder}
        style={{ height: isOpen ? "auto" : 0 }}
      >
        {items
          ? items.map((link, idx) => {
              //  let active = (location.pathname.indexOf(link.route) > -1 && link.route.length >= location.pathname.length)?true:false;
              const pathname = `${location.pathname}${location.search}`;
              let active = pathname.indexOf(link.route) > -1 ? true : false;
              if (active && activeLink.length < pathname.length) {
                activeLink = link.route;
              }

              if (activeLink === link.route) {
                active = true;
                if (
                  link.route !== "/wip/studio" &&
                  activeLink === "/wip" &&
                  pathname.indexOf("/wip/studio") > -1
                ) {
                  active = false;
                }
              } else {
                active = false;
              }

              return (
                <div key={idx}>
                  <SubMenuLink
                    {...link}
                    key={link.label}
                    active={active ? true : false}
                    onClick={(val) => onClick(val)}
                  />
                </div>
              );
            })
          : null}
      </Box>
    </Box>
  );
}

const iconSize = 24;
const strokeWidth = AppConstants.ICON_STROKE_WIDTH;
export const menuData = [
  {
    icon: <IconLivePhoto size={iconSize} strokeWidth={strokeWidth} />,
    color: "blue",
    label: "Latest Assets",
    route: "/feed",
  },
  {
    icon: <IconHome size={iconSize} strokeWidth={strokeWidth} />,
    color: "blue",
    label: "Dashboard",
    route: "/home/dashboard",
  },
  {
    icon: <IconRocket size={iconSize} strokeWidth={strokeWidth} />,
    color: "yellow",
    label: "Distrbutions",
    route: "/distributions",
    // items: [
    //     { label: 'Dashboard', route: '/distributions/dashboard' },
    //     { label: 'Events', route: '/seasons' },
    //     { label: 'Sessions', route: '/sessions' },
    //     { label: 'All Tasks', route: '/sessions/tasks' },
    //     // { label: 'Quick Tasks', route: '/sessions/quicktasks' },
    // ],
  },
  {
    icon: <IconCalendarEvent size={iconSize} strokeWidth={strokeWidth} />,
    color: "blue",
    label: "WIP",
    route: "/wip/studio",
    // items: [
    //   { label: "Studio", route: "/wip/studio" },
    //   { label: "Production", route: "/wip/production" },
    //   { label: "Post Production", route: "/wip/postproduction" },
    //   // { label: 'Quick Tasks', route: '/sessions/quicktasks' },
    // ],
  },
  {
    icon: <IconCameraCheck size={iconSize} strokeWidth={strokeWidth} />,
    color: "blue",
    label: "Approvals",
    route: "/approval/production",
    items: [
      { label: "Production", route: "/approval/production" },
      { label: "Post Production", route: "/approval/postproduction" },
      // { label: 'Quick Tasks', route: '/sessions/quicktasks' },
    ],
  },
  {
    icon: <IconUserScan size={iconSize} strokeWidth={strokeWidth} />,
    color: "blue",
    label: "Talent",
    route: "/talent",
  },

  // { icon: <IconCamera size={iconSize} strokeWidth={strokeWidth} />, color: 'blue', label: 'Assets', route: '/assets' },
];

export function MainLinks({ callBack, selectedMenu }) {
  const onClick = (route) => {
    callBack(route);
  };

  const isActive = (link, menu) => {
    var active = false;
    
    if (link && menu) {
      if (link.route.indexOf(menu.route) > -1) {
        active = true;
      }
      // if no match check the children
      if (!active) {
        const item = menu.items?.find((val) => val.route === link.route);
        active = item ? true : false;
      }
    }

    return active;
  };

  const links = menuData.map((link, key) => {
    return (
      <div key={key}>
        <MainLink
          {...link}
          active={isActive(selectedMenu, link)}
          key={link.label}
          onClick={(val) => onClick(val)}
        />
      </div>
    );
  });

  return <Stack gap={2}>{links}</Stack>;
}

function SubMenuLink({ icon, color, label, route, items, onClick, active }) {
  const { classes } = useStyles();
  const buttonClick = () => {
    onClick({ label, route });
  };
  const cls = active ? "active" : "";

  return (
    <UnstyledButton
      onClick={buttonClick}
      className={[classes.menuItem, cls]}
      style={{
        borderRadius: 0,
        paddingLeft: 34,
        transition: "all .2s",
      }}
    >
      <Group wrap={false}>
        <Text size="sm">{label}</Text>
      </Group>
    </UnstyledButton>
  );
}
